/** @type {import("@/types/data/ClientConfig.mjs").ClientConfig} */
export default {
  api: null,
  service: null,
  store: null,
  browser: null,
  browserVer: 0,
  designsBucket: null,
  dataModelVersion: null,
  uploadBucket: null,
  sitesBucket: null,
  designsBackupBucket: null,
  previewBucket: null,
  previewDomain: null,
  siteDomain: null,
  assetURL: null,
  googleFontsUrl: false,
  instagramMediaUrl: false,
  awsURL: "//s3-external-1.amazonaws.com",
  libraryURL: "//lib.showit.com",
  engineVersion: null,
  debugJSON: false,
  devMode: false,
  isOSX: false,
  initView: null,
  demoMode: false,
  adminURL: null,
  accountURL: null,
  lostPasswordURL: null,
  createAccountURL: null,
};
